import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class KentDiscoverSwiper {
  private swiper: Swiper | null = null;

  constructor() {
    this._init();
  }

  private _init() {
    const swiperElement = document.querySelector('.kent-discover__swiper');
    if (swiperElement) {
      this.swiper = new Swiper(swiperElement as HTMLElement, {
        direction: 'horizontal',
        modules: [Navigation],
        slidesPerView: 1.5,
        spaceBetween: 20,
        effect: 'fade',
        autoHeight: true,
        navigation: {
          enabled: true,
          nextEl: '.kent-discover__swiper-button--next',
          prevEl: '.kent-discover__swiper-button--prev',
        },
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: true,
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new KentDiscoverSwiper();
});
